import { css, styled } from 'styled-components';

const RawButton = styled('button')(
  () => css`
    all: unset;
    outline: revert;
  `
);

export default RawButton;
